// features.js
export default [
  {
    id: 'upload_image',
    name: '이미지 업로드',
    icon: '/images/이미지 업로드.png?v=20260806', //'⬆️',
    iconTone: 'orange',
    description: '편집할 이미지를 업로드합니다.'
  },
  {
    id: 'style_transform',
    name: '스타일 변환',
    icon: '/images/스타일 변환.png?v=20260806',
    description: '반려견 이미지를 원하는 아트·사진 스타일로 변환합니다.'
  },
  {
    id: 'emoticon_style',
    name: '이모티콘',
    icon: '/images/imogi.png',
    description: '다양한 표정과 포즈의 반려견 이모티콘 시트를 만듭니다.'
  },
  {
    id: 'advanced_style_transform',
    name: '고급 스타일 변환',
    icon: '/images/고급_스타일_변환.png',
    description: '포스터·4컷 만화·인포그래픽처럼 완성도 높은 결과를 생성합니다.'
  },
  {
    id: 'image_composite',
    name: '이미지 합성',
    icon: '/images/이미지 합성.png',
    description: '두 이미지를 한 장면으로 자연스럽게 합성합니다.'
  },
  {
    id: 'find_mbti',
    name: '반려견 MBTI',
    icon: '/images/mbti.png',
    description: '12문항 테스트로 반려견의 MBTI를 고르고 기념 이미지를 생성합니다.'
  },
  {
    id: 'make_video',
    name: '동영상 생성 · 준비 중',
    disabled: true,
    icon: '/images/동영상.png',
    description: '사진 속 반려견을 짧고 생동감 있는 영상으로 만듭니다.'
  },
];
